export const MODULE_KEY = 'checkoutPage';

export const STRIPE_SCRIPT_SRC = 'https://js.stripe.com/v3/';
